import * as base from "./baseArea";

export const castStringPropsToNumbers = (area) => {
  return base.castAreaStringPropsToNumbers(area, [
    "width",
    "length",
    "height",
    "doors",
    "windows",
  ]);
};

export const calculateTotalArea = (area) => {
  return (
    base.calculateWallArea(area) +
    base.calculateWindowPanelArea(area) -
    base.calculateDoorPanelArea(area)
  );
};
